import { Dispatch, Action } from 'redux';
import axios from 'axios';
import { AdminUser } from '../reducers/adminUsers.reducer'
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
// import { NotificationManager } from 'react-notifications';
import { getAdminUserAPI, getAdminUsersAPI, addAdminUserAPI, editAdminUserAPI, deleteAdminUserAPI } from '../../config/config'


// Action types
export const GET_ADMINUSERS_REQUEST = 'GET_ADMINUSERS_REQUEST';
export const GET_ADMINUSERS_SUCCESS = 'GET_ADMINUSERS_SUCCESS';
export const GET_ADMINUSERS_FAILURE = 'GET_ADMINUSERS_FAILURE';

export const GET_ADMINUSER_REQUEST = 'GET_ADMINUSER_REQUEST';
export const GET_ADMINUSER_SUCCESS = 'GET_ADMINUSER_SUCCESS';
export const GET_ADMINUSER_FAILURE = 'GET_ADMINUSER_FAILURE';

export const ADD_ADMINUSER_REQUEST = 'ADD_ADMINUSER_REQUEST';
export const ADD_ADMINUSER_SUCCESS = 'ADD_ADMINUSER_SUCCESS';
export const ADD_ADMINUSER_FAILURE = 'ADD_ADMINUSER_FAILURE';

export const EDIT_ADMINUSER_REQUEST = 'EDIT_ADMINUSER_REQUEST';
export const EDIT_ADMINUSER_SUCCESS = 'EDIT_ADMINUSER_SUCCESS';
export const EDIT_ADMINUSER_FAILURE = 'EDIT_ADMINUSER_FAILURE';

export const DELETE_ADMINUSER_REQUEST = 'DELETE_ADMINUSER_REQUEST';
export const DELETE_ADMINUSER_SUCCESS = 'DELETE_ADMINUSER_SUCCESS';
export const DELETE_ADMINUSER_FAILURE = 'DELETE_ADMINUSER_FAILURE';

export const SET_ADD_ADMINUSER_POPUP = 'SET_ADD_ADMINUSER_POPUP';
export const SET_EDIT_ADMINUSER_POPUP = 'SET_EDIT_ADMINUSER_POPUP';
export const SET_DELETE_ADMINUSER_POPUP = 'SET_DELETE_ADMINUSER_POPUP';

export const RESET_ADMINUSER_STATE = 'RESET_ADMINUSER_STATE'

export interface AddAdminUserProps {
  firstName: string;
  lastName: string;
  email: string;
  adminType: string | "admin";
}

export interface EditAdminUserProps {
  firstName: string;
  lastName: string;
  email: string;
  adminType: string | "admin";
}

interface DeleteAdminUserProps {
  target: string | number;
}


interface GetAdminUsersRequest extends Action<typeof GET_ADMINUSERS_REQUEST> { }
interface GetAdminUsersSuccess extends Action<typeof GET_ADMINUSERS_SUCCESS> {
  payload: AdminUser[]
}
interface GetAdminUsersFailure extends Action<typeof GET_ADMINUSERS_FAILURE> {
  payload: string
}

interface GetAdminUserRequest extends Action<typeof GET_ADMINUSER_REQUEST> { }
interface GetAdminUserSuccess extends Action<typeof GET_ADMINUSER_SUCCESS> {
  payload: AdminUser
}
interface GetAdminUserFailure extends Action<typeof GET_ADMINUSER_FAILURE> {
  payload: string
}

interface AddAdminUserRequest extends Action<typeof ADD_ADMINUSER_REQUEST> { }
interface AddAdminUserSuccess extends Action<typeof ADD_ADMINUSER_SUCCESS> { }
interface AddAdminUserFailure extends Action<typeof ADD_ADMINUSER_FAILURE> {
  payload: string
}

interface EditAdminUserRequest extends Action<typeof EDIT_ADMINUSER_REQUEST> { }
interface EditAdminUserSuccess extends Action<typeof EDIT_ADMINUSER_SUCCESS> { }
interface EditAdminUserFailure extends Action<typeof EDIT_ADMINUSER_FAILURE> {
  payload: string
}

interface DeleteAdminUserRequest extends Action<typeof DELETE_ADMINUSER_REQUEST> { }
interface DeleteAdminUserSuccess extends Action<typeof DELETE_ADMINUSER_SUCCESS> { }
interface DeleteAdminUserFailure extends Action<typeof DELETE_ADMINUSER_FAILURE> {
  payload: string
}

interface SetAddPLanPopUp extends Action<typeof SET_ADD_ADMINUSER_POPUP> {
  payload: boolean;
}

interface SetEditPLanPopUp extends Action<typeof SET_EDIT_ADMINUSER_POPUP> {
  payload: boolean;
}

interface SetDeletePLanPopUp extends Action<typeof SET_DELETE_ADMINUSER_POPUP> {
  payload: boolean;
}

interface ResetAdminUserState extends Action<typeof RESET_ADMINUSER_STATE> {}

export type ActionTypes = GetAdminUsersRequest | GetAdminUsersSuccess | GetAdminUsersFailure
  | GetAdminUserRequest | GetAdminUserSuccess | GetAdminUserFailure
  | AddAdminUserRequest | AddAdminUserSuccess | AddAdminUserFailure
  | EditAdminUserRequest | EditAdminUserSuccess | EditAdminUserFailure
  | DeleteAdminUserRequest | DeleteAdminUserSuccess | DeleteAdminUserFailure
  | SetAddPLanPopUp | SetEditPLanPopUp | SetDeletePLanPopUp
  | ResetAdminUserState

// Action creators
const getAdminUsersRequest = (): GetAdminUsersRequest => ({ type: GET_ADMINUSERS_REQUEST });
const getAdminUsersSuccess = (data: AdminUser[]): GetAdminUsersSuccess => ({ type: GET_ADMINUSERS_SUCCESS, payload: data });
const getAdminUsersFailure = (error: string): GetAdminUsersFailure => ({ type: GET_ADMINUSERS_FAILURE, payload: error });

const getAdminUserRequest = (): GetAdminUserRequest => ({ type: GET_ADMINUSER_REQUEST });
const getAdminUserSuccess = (data: AdminUser): GetAdminUserSuccess => ({ type: GET_ADMINUSER_SUCCESS, payload: data });
const getAdminUserFailure = (error: string): GetAdminUserFailure => ({ type: GET_ADMINUSER_FAILURE, payload: error });

const addAdminUserRequest = (): AddAdminUserRequest => ({ type: ADD_ADMINUSER_REQUEST });
const addAdminUserSuccess = (): AddAdminUserSuccess => ({ type: ADD_ADMINUSER_SUCCESS });
const addAdminUserFailure = (error: string): AddAdminUserFailure => ({ type: ADD_ADMINUSER_FAILURE, payload: error });

const editAdminUserRequest = (): EditAdminUserRequest => ({ type: EDIT_ADMINUSER_REQUEST });
const editAdminUserSuccess = (): EditAdminUserSuccess => ({ type: EDIT_ADMINUSER_SUCCESS });
const editAdminUserFailure = (error: string): EditAdminUserFailure => ({ type: EDIT_ADMINUSER_FAILURE, payload: error });

const deleteAdminUserRequest = (): DeleteAdminUserRequest => ({ type: DELETE_ADMINUSER_REQUEST });
const deleteAdminUserSuccess = (): DeleteAdminUserSuccess => ({ type: DELETE_ADMINUSER_SUCCESS });
const deleteAdminUserFailure = (error: string): DeleteAdminUserFailure => ({ type: DELETE_ADMINUSER_FAILURE, payload: error });

const setAddAdminUserPopup = (value: boolean): SetAddPLanPopUp => ({ type: SET_ADD_ADMINUSER_POPUP, payload: value });
const setEditAdminUserPopup = (value: boolean): SetEditPLanPopUp => ({ type: SET_EDIT_ADMINUSER_POPUP, payload: value });
const setDeleteAdminUserPopup = (value: boolean): SetDeletePLanPopUp => ({ type: SET_DELETE_ADMINUSER_POPUP, payload: value });

const resetAdminUserState = (): ResetAdminUserState => ({type:RESET_ADMINUSER_STATE})


// Async action creators
const getAdminUsers = () => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(getAdminUsersRequest());
      const response = await getAdminUsersAPI()
      dispatch(getAdminUsersSuccess(response?.data?.users || []))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getAdminUsersFailure(error.message));
    }
  };
};

const getAdminUser = (uuid: string) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(getAdminUserRequest());
      const response = await getAdminUserAPI(uuid)
      dispatch(getAdminUserSuccess(response?.data?.users || {}))

    } catch (error: any) {
      console.log('error', error)
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(getAdminUserFailure(error.message));
    }
  };
};

const addAdminUser = (data: AddAdminUserProps): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      dispatch(addAdminUserRequest());

      const response = await addAdminUserAPI(data)
      dispatch(addAdminUserSuccess());
      dispatch(getAdminUsers()); // Call the getAdminUsers action after adding a adminUser
      dispatch(setAddAdminUserPopup(false))
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(addAdminUserFailure(error.message));
    }
  };
};

const editAdminUser = (data: AddAdminUserProps, uuid: string): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  const token = window.localStorage.getItem('token');
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      dispatch(editAdminUserRequest());
      const response = await editAdminUserAPI(data, uuid)
      dispatch(editAdminUserSuccess());
      dispatch(getAdminUsers()); // Call the getAdminUsers action after adding a adminUser
      dispatch( updateEditAdminUserPopup(false))
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(editAdminUserFailure(error.message));
    }
  };
};

const deleteAdminUser = (uuid: string): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    try {
      dispatch(deleteAdminUserRequest());
      const response = await deleteAdminUserAPI(uuid)
      dispatch(deleteAdminUserSuccess());
      dispatch(getAdminUsers()); // Call the getAdminUsers action after adding a adminUser
      dispatch(updateDeleteAdminUserPopup(false))
    } catch (error: any) {
      console.log('error', error);
      //   NotificationManager.error(error?.response?.data?.message || error?.message || 'Something went wrong')
      dispatch(deleteAdminUserFailure(error.message));
    }
  };
};

const updateAddAdminUserPopup = (value: boolean): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(setAddAdminUserPopup(value))
  };
}

const updateEditAdminUserPopup = (value: boolean): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(setEditAdminUserPopup(value))
  };
}

const updateDeleteAdminUserPopup = (value: boolean): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(setDeleteAdminUserPopup(value))
  };
}

const resetAll = (): ThunkAction<Promise<void>, any, any, ActionTypes> => {
  return async (dispatch: ThunkDispatch<any, any, ActionTypes>) => {
    dispatch(resetAdminUserState())
  };
}


const actions = {
  getAdminUsers,
  addAdminUser,
  editAdminUser,
  getAdminUser,
  deleteAdminUser,
  updateAddAdminUserPopup,
  updateEditAdminUserPopup,
  updateDeleteAdminUserPopup,
  resetAll
}

export default actions
